import * as Sentry from "@sentry/react";

const SENTRY_DSN =
  import.meta.env.VITE_SENTRY_DSN ||
  "https://0623847389eacefe23677c7f435b8b10@o4510979358654464.ingest.de.sentry.io/4511418579877968";

let initialized = false;

export const initClientObservability = () => {
  if (!SENTRY_DSN || initialized) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    sendDefaultPii: true,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
    beforeSend(event) {
      if (event.request?.headers) {
        delete event.request.headers.Authorization;
        delete event.request.headers.Cookie;
      }
      return event;
    },
  });

  initialized = true;
};

export const setObservabilityUser = (user: { id: string } | null) => {
  Sentry.setUser(user ? { id: user.id } : null);
};
